<template>
	<div class="menu-right">
    <div class="title">MEUS PEDIDOS</div>
    <div class="box-filtros-menu">
			<a class="filtro-link" @click="clearFilters()">TODOS</a>
			<div class="header-accordion">
				FILTROS
			</div>
			<div class="content">
				<div class="box-check">
					<input class="styled-checkbox" id="1" type="checkbox" v-model="filters[0].pendencias">
					<label for="1">Pendências</label>
					<input class="styled-checkbox" id="2" type="checkbox" v-model="filters[0].aguardandocliente">
					<label for="2">Aguardando Cliente</label>
          <input class="styled-checkbox" id="3" type="checkbox" v-model="filters[0].andamento">
          <label for="3">Em andamento</label>
					<input class="styled-checkbox" id="4" type="checkbox" v-model="filters[0].concluidos">
					<label for="4">Concluído</label>
					<input class="styled-checkbox" id="5" type="checkbox" v-model="filters[0].cancelados">
					<label for="5">Cancelado</label>
				</div>
			</div>
			<div class="box-sem-margin">
				<div class="title">PROTOCOLO</div>
				<input type="text" v-model="filters[0].protocolo">
			</div>
			<div class="box-sem-margin">
				<div class="title">DATA INICIAL</div>
				<template>
					<flat-pickr v-model="filters[0].dataIni" :config="flatConfig"></flat-pickr>
					<i class="fas fa-calendar-alt"></i>
				</template>
			</div>
			<div class="box-sem-margin">
				<div class="title">DATA FINAL</div>
				<template>
					<flat-pickr v-model="filters[0].dataFim" :config="flatConfig"></flat-pickr>
					<i class="fas fa-calendar-alt"></i>
				</template>
			</div>
			<div class="btn-center">
				<button class="btn-padrao" @click="emit">
					<i class="fas fa-search"></i>
					<span>BUSCAR</span>
				</button>
			</div>
		</div>
	</div>
</template>
<script>
	import { mapGetters } from 'vuex';
	import { Portuguese } from 'flatpickr/dist/l10n/pt.js';
	import formatMixin from '../../../../../../../../../resources/assets/js/mixins/formatMixin';

	export default {
		mixins: [formatMixin],
		props : {
			filtros: [Object, Array]
		},
		data() {
			return {
				flatConfig: {locale: Portuguese, dateFormat: 'd/m/Y'},
				filters : [{ 
					pendencias : this.filtros.pendencias ? this.filtros.pendencias : false,
					aguardandocliente : this.filtros.aguardandocliente ? this.filtros.aguardandocliente : false,
					andamento : this.filtros.andamento ? this.filtros.andamento : false,
					concluidos : this.filtros.concluidos ? this.filtros.concluidos : false,
					cancelados : this.filtros.cancelados ? this.filtros.cancelados : false,
					protocolo : this.filtros.protocolo ? this.filtros.protocolo : '',
					dataIni : this.filtros.dataIni ? this.filtros.dataIni : '',
					dataFim : this.filtros.dataFim ? this.filtros.dataFim : ''
				}]
			}
		},
		methods: {
			emit() {
				let scope   = this;
				var filtros = this.filters;
				this.$emit('changeFiltros', filtros);
			},
			clearFilters() {
				this.filters[0].pendencias = '';
				this.filters[0].aguardandocliente = '';
				this.filters[0].andamento = '';
				this.filters[0].concluidos = '';
				this.filters[0].cancelados = '';
				this.filters[0].protocolo = '';
				this.filters[0].dataIni = '';
				this.filters[0].dataFim = '';
				this.emit();
			},
			flatPickr() {
				let elements = Array.prototype.slice.call(document.getElementsByClassName('flatpickr-weekdaycontainer'));

				Array.prototype.forEach.call(elements, function(el) {
					let fragment = document.createDocumentFragment();

					while(el.firstChild) {
						fragment.appendChild(el.firstChild);
					}
					el.parentNode.replaceChild(fragment, el);
				});
			},

		},
		updated() {
			this.flatPickr();
		},
		mounted() {
				if (this.filters.dataIni)
				{
					this.filters.dataIni = this.filters.dataIni.replace('*', '/');
					this.filters.dataIni = this.filters.dataIni.replace('*', '/');
				}
				if (this.filters.dataFim)
				{
					this.filters.dataFim = this.filters.dataFim.replace('*', '/');
					this.filters.dataFim = this.filters.dataFim.replace('*', '/');
				}
			}		
	};
</script>